module.exports = __webpack_public_path__ + "img/logo_maraton_hudby_brno_datum.7efe6101.svg";